
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import GmapOverlayView from '@/components/GmapOverlayView'

@Component({
  components: {
    GmapOverlayView
  }
})
export default class GmapOverlayViewer extends Vue {
  @Prop({ type: Array }) overlays!: string[]

  getLatLngBounds (bounds: { south: number; west: number; north: number; east: number; }) {
    if (google) {
      return new google.maps.LatLngBounds(
        // TODO: Ugliest hack ever. For some reason this fix a problem with the placement
        new google.maps.LatLng(bounds.south, bounds.west),
        new google.maps.LatLng(bounds.north, bounds.east)
      )
    }
    return {}
  }
}
